import { asyncApiCall } from "../utils/services";

export class Services {
    apiUrl;
    headers;

    constructor(apiUrl, token) {
        this.apiUrl = apiUrl;
        this.headers = { "X-KSYS-TOKEN": token, "X-KSYS-EXPERIMENTAL-TRANSLATION": true };
    }

    getData = async (
        fundList, 
        filterSearch, 
        identifierSearch, 
        sort,
        advancedSort,
        documentsJoinSpec, 
        start, 
        limit, 
        cultureCode, 
        sourceCulture, 
        timeseriesInclude, 
        statisticsInclude, 
        allocationsInclude
        ) => {
        const body = {
            "type": "CLSS",
            "clientCode": [""],
            "fundList": fundList,
            "search": filterSearch,
            "identifierSearch": identifierSearch,
            "sort": sort,
            "advancedSort": advancedSort,
            "include": {
                "documents": {
                    "joinSpec": documentsJoinSpec
                },
                "timeseries": timeseriesInclude,
                "statistics": statisticsInclude,
                "allocations": allocationsInclude,
                "disclaimers": {},
                "commentaries": {},
                "fundManagers": {}
            },
            "limit": limit,
            "start": start,
            "culture": cultureCode,
            "sourceCulture": sourceCulture,
            "translate": true,
            "applyFormats": true,
            "disclaimers": true
        };

        const URL = `${this.apiUrl}/services/fund/searchEntity`;

        const result = await asyncApiCall(URL, {
            headers: this.headers,
            body
        });

        return result;
    }

    getFilters = async (filterProperties = [], search = [], fundList = "") => {
        const body = {
            "type": "CLSS",
            "filterProperties": filterProperties,
            "search": search,
            "fundList": [fundList]
        };

        const URL = `${this.apiUrl}/services/fund/getFilters`;

        const result = await asyncApiCall(URL, {
            headers: this.headers,
            body
        });

        return result;
    }

    getDocumentFilters = async (codes = [], search = []) => {
        const body = {
            "type": "CLSS",
            "codes": codes,
            "search": search
        };

        const URL = `${this.apiUrl}/services/documents/getFilters`;

        const result = await asyncApiCall(URL, {
            headers: this.headers,
            body
        });

        return result;
    }

    getTranslation = async (culture) => {
        const body = {
            culture
        };

        const URL = `${this.apiUrl}/services/config/listtranslations`;

        const result = await asyncApiCall(URL, {
            headers: this.headers,
            body
        });

        return result;
    }

    documentDownload = async (clientCode) => {
        const body = {
            clientCode
        };

        const URL = `${this.apiUrl}/services/documents/retrieveDocument`;

        const result = await asyncApiCall(URL, {
            headers: this.headers,
            body
        });

        return result;
    }

    documentDownloadZip = async (documentCodes) => {
        const body = {
            documentCodes
        };

        const URL = `${this.apiUrl}/services/documents/retrieveDocumentZip`;

        const result = await asyncApiCall(URL, {
            headers: this.headers,
            body
        });

        return result;
    }

    getCultures = async () => {
        const body = {};

        const URL = `${this.apiUrl}/services/config/listCultures`;

        const result = await asyncApiCall(URL, {
            headers: this.headers,
            body
        });

        return result;
    }

    getDisclaimers = async () => {
        const body = {};

        const URL = `${this.apiUrl}/services/config/listDisclaimers`;

        const result = await asyncApiCall(URL, {
            headers: this.headers,
            body
        });

        return result;
    }
}


// WEBPACK FOOTER //
// ./src/services/services.ts